// --- API ---
import { useSubmitCatalogueFormMutation } from "../partials/PageContent/catalogueForm/api/catalogueApi";
import { useSubmitContactFormMutation } from "../templates/contact/api/contactApi";
import { useSubmitFranchiseFormMutation } from "../templates/franchise/api/franchiseApi";

// --- Validation (The Factories) ---
// We export the factories so themes can create their own versions
import { createCatalogueFormSchema } from "../partials/PageContent/catalogueForm/helpers/catalogueValidation";
import { createContactFormSchema } from "../templates/contact/helpers/contactValidation";
import { createFranchiseFormSchema } from "../templates/franchise/helpers/franchiseValidation";

// --- Components ---
import CatalogueForm from "../partials/PageContent/catalogueForm/components/CatalogueForm";
import ContactForm from "../templates/contact/components/ContactForm";
import FranchiseForm from "../templates/franchise/components/FranchiseForm";

export const forms = {
  api: {
    useSubmitCatalogueFormMutation,
    useSubmitContactFormMutation,
    useSubmitFranchiseFormMutation,
  },
  validation: {
    createCatalogueFormSchema,
    createContactFormSchema,
    createFranchiseFormSchema,
  },
  components: {
    CatalogueForm,
    ContactForm,
    FranchiseForm,
  },
};
